/**
 * @file MentionsLegales.tsx
 * @summary Page légale
 *
 * Page de mentions légales / RGPD / CGU / cookies. Conformité Privacy by design — cookies essentiels uniquement.
 *
 * @see docs/07-CODEBASE.md — conventions de code
 * @see docs/02-FRONTEND.md — design system (tokens HSL, typographie)
 */
import LegalPage from "@/components/LegalPage";

export default function MentionsLegales() {
  return (
    <LegalPage
      title="Mentions légales"
      subtitle="Transparence sur l'éditeur, l'hébergement et les droits"
      canonicalPath="/legal/mentions"
      seoTitle="Mentions légales — CrossFit Chistera"
      seoDescription="Mentions légales du site CrossFit Chistera : éditeur MOJO SARL (RCS Lyon 922 456 108), hébergeur OVHcloud, contact RGPD, propriété intellectuelle et marque CrossFit."
      remember={[
        "Éditeur : MOJO SARL — RCS Lyon 922 456 108",
        "Hébergeur : OVHcloud, Roubaix",
        "CrossFit : marque sous licence/affiliation",
        "Cookies : techniques uniquement",
        "Contact : contact@crossfitchistera.com",
      ]}
    >
      <h2>Éditeur du site</h2>
      <p>Le présent site est édité par la société MOJO, Société à responsabilité limitée (SARL), immatriculée au RCS de Lyon sous le numéro 922 456 108, dont le siège social est situé 37 rue Pierre et Marie Curie, lieudit la Maladière, 69780 Saint-Pierre-de-Chandieu, France, exploitant notamment la marque commerciale « CrossFit Chistera ».</p>

      <h2>Directeurs de la publication</h2>
      <p>Le directeur de la publication est Cédric Bastien, co-gérant. Les gérants de la société sont : Anthony Bendahmane et Cédric Bastien, également appelés « les coachs ».</p>

      <h2>Contact</h2>
      <ul>
        <li>Contact général : sur place, via les coachs de la box</li>
        <li>Contact (y compris contact RGPD) : <a href="mailto:contact@crossfitchistera.com">contact@crossfitchistera.com</a></li>
      </ul>

      <h2>Hébergeur</h2>
      <p>Le site est hébergé par OVHcloud (OVH SAS), 2 rue Kellermann, 59100 Roubaix, France, RCS Lille Métropole 424 761 419 00045.</p>

      <h2>Objet du site</h2>
      <p>Le site est un site vitrine présentant la salle, ses activités, ses horaires, ses coachs, ses actualités et permettant d'adresser une demande via un formulaire (contact, demande de séance d'essai, demande de drop-in). Le site ne permet pas la réservation directe de créneaux en ligne.</p>

      <h2>Marque CrossFit</h2>
      <p>« CrossFit » est une marque appartenant à CrossFit, LLC. L'usage du nom CrossFit par CrossFit Chistera s'inscrit dans le cadre d'une affiliation sous forme de licence commerciale.</p>

      <h2>Propriété intellectuelle</h2>
      <p>Le site, sa structure, ses textes, visuels, logos, photographies, vidéos, bases de données et plus généralement l'ensemble des éléments composant le site sont protégés et restent notre propriété exclusive ou font l'objet de droits d'usage. Toute reproduction, représentation, adaptation, extraction, réutilisation ou diffusion (même partielle), sans autorisation écrite préalable, est interdite.</p>
      <p>Toute exploitation non autorisée du site ou de l'un des éléments qu'il contient sera considérée comme constitutive d'une contrefaçon et pourra être poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.</p>

      <h2>Données personnelles</h2>
      <p>Les informations relatives aux traitements de données personnelles figurent dans la <a href="/legal/rgpd">Politique RGPD</a> du site.</p>

      <h2>Cookies</h2>
      <p>Nous n'utilisons aucun cookie de mesure d'audience ni publicitaire. Le fonctionnement du site peut reposer uniquement sur des traceurs techniques strictement nécessaires, déposés le temps de la navigation et supprimés à la fermeture du navigateur.</p>

      <p>Voir aussi : <a href="/legal/cgu">CGU</a> · <a href="/legal/cgv">CGV</a> · <a href="/legal/rgpd">Politique RGPD</a> · <a href="/lexique">Lexique</a></p>
    </LegalPage>
  );
}
